import { Injectable } from '@angular/core';
import { ProductsService } from '@core/services/products.service';
import { IPreviewCard } from '../components/preview-card/IPreviewClass';
import { map, Observable, of } from 'rxjs';
import { Product } from '@core/models/piramide/Product';

@Injectable({
  providedIn: 'root',
})
export class NvidiaSectionService {
  private productsIds: number[] = [
    15254, 15255, 15257, 15258, 15585, 15596, 15892, 16582, 15627, 16033, 16164, 16537, 16781,
    16883, 16988, 16866,
  ];
  constructor(private _productsService: ProductsService) {}
  public getNvidiaPreview(): Observable<IPreviewCard> {
    return of({
      id: 78,
      title: 'NVIDIA GeForce RTX',
      class: 'brand',
      backgroundImages: [
        {
          tipo: 3,
          imagen: 'assets/img/seccion-nvidia/nvidia_secundaria.jpg',
        },
        {
          tipo: 2,
          imagen: 'assets/img/seccion-nvidia/nvidia_principal.jpg',
        },
      ],
    });
  }

  public getNvidiaProducts(): Observable<Product[]> {
    return this._productsService.products$.pipe(
      map((r) => {
        return r.filter((p) => this.productsIds.includes(p.id_producto));
      }),
    );
  }
}
